// src/components/singlePost/SinglePost.jsx
import axios from "axios";
import { useContext, useEffect, useState } from "react";
import { useLocation } from "react-router";
import { Link } from "react-router-dom";
import { Context } from "../../context/Context";
import "./singlePost.css";
import React from "react";
import {
  FacebookShareCount,
  FacebookIcon,
  TwiterShareCount,
  TwitterIcon,
  FacebookShareButton,
  TwitterShareButton,
} from "react-share";
import MyEditor from "./MyEditor";
import { decodeHtml } from "../../utils/utils";
import { toast } from "react-toastify";
import { Helmet } from "react-helmet";
import { useMemo } from "react";

const PF = process.env.REACT_APP_AWS_S3_IMAGE_URL;

export default function SinglePost() {
  const location = useLocation();
  const slug = location.pathname.split("/").filter(Boolean).pop();

  let postObj = {
    postId: 0,
    title: "",
    shortDesc: "",
    desc: "",
    photo: "",
    authorId: 0,
    categories: [],
    tags: [],
    views: 0,
    likes: [],
    shares: [],
    published: false,
  };
  const [post, setPost] = useState(postObj);

  const { user, dispatch, token } = useContext(Context);
  const [desc, setDesc] = useState("");
  const [authorId, setAuthorId] = useState(1);
  let profilePic = "";
  let isPro = false;

  const [updateMode, setUpdateMode] = useState(false);
  const [posts, setPosts] = useState([]);
  const [tags, setTags] = useState([]);
  const [users, setUsers] = useState([]);
  const [active1, setActive1] = useState(false);
  const [active2, setActive2] = useState(false);
  const [active3, setActive3] = useState(false);
  const [warning, setWarning] = useState("");
  const [followers, setFollowers] = useState(0);
  let authorName = "";
  let authorBio = "";

  useEffect(() => {
    const getPost = async () => {
      try {

        const headers = token ? { Authorization: `Bearer ${token}` } : {};
        const isPreviewRoute = location.pathname.startsWith("/preview/");
        const url = isPreviewRoute
          ? `/posts/slug/${slug}?includeDrafts=true`
          : `/posts/slug/${slug}`;
        const res = await axios.get(url, { headers });

        if (res.status !== 200 || !res.data || !res.data._id) {
          toast.info(res.data?.message || "Post not found");
          return;
        }

        setPost(res.data);
        setAuthorId(res.data.authorId);
        setTags(res.data.tags || []);

        if (user) {
          if (res.data.likes.includes(user.userId)) setActive1(true);
          if (user.readingList.includes(res.data._id)) setActive2(true);
          if (user.followings.includes(res.data.authorId)) setActive3(true);
        }
      } catch (err) {
        console.error(err);
        toast.error("Error Fetching Post!");
      }
    };

    getPost();
  }, [slug, token, location.pathname]);

  const [members, setMembers] = useState([]);

  useEffect(() => {
    const getMembers = async () => {
      try {
        const res = await axios.get("/members");
        if (res.status !== 200) {
          toast.info(res.data.message);
        }
        setMembers(res.data);
      } catch (err) {
        console.error(err);
        toast.error("Error Getting Members!");
      }
    };
    getMembers();
  }, []);

  let checkMember = user !== null ? user.isMember : false;
  let current = new Date();

  if (members.length > 0 && user != null) {
    for (var i = 0; i < members.length; i++) {
      if (members[i].user_id === user._id) {
        var expired_date = new Date(members[i].end_date);
        if (expired_date.getTime() < current.getTime()) {
          user.isMember = false;
          checkMember = false;
        } else {
          user.isMember = true;
          checkMember = true;
        }
      }
    }
  }

  useEffect(() => {
    const getUsers = async () => {
      try {
        const res = await axios.get("/users");
        if (res.status !== 200 || res.status === 404) {
          toast.info(res.data.message);
          return;
        }
        setUsers(res.data);
      } catch (err) {
        console.error(err);
        toast.error("Error Getting Users!");
      }
    };
    const fetchPosts = async () => {
      try {
        const res = await axios.get("/posts/published");
        if (res.status !== 200) {
          toast.info(res.data.message);
        }
        setPosts(res.data);
      } catch (err) {
        console.error(err);
        toast.error("Error Fetching Posts!");
      }
    };
    fetchPosts();
    getUsers();
  }, []);

  for (var i = 0; i < users.length; i++) {
    if (users[i].userId === post.authorId) {
      authorName = users[i].user_name;
      authorBio = users[i].bio;
      profilePic =
        users[i].avatar_urls["full"] == null
          ? users[i].profilePic
          : PF + users[i].avatar_urls["full"];
      isPro = users[i].isPro;
      break;
    }
  }

  useEffect(() => {
    const getFollowers = async () => {
      try {
        const res2 = await axios.get("/users/followers/" + authorId);

        setFollowers(res2.data.length);
      } catch (err) {
        if (err.response && err.response.status !== 404) {
          console.error(err);
          toast.error("Error Getting Followers!");
        }
      }
    };

    if (authorId) getFollowers();
  }, [authorId]);

  const handleDelete = async () => {
    if (window.confirm("Are you sure?") === true) {
      try {
        await axios.delete(
          `/posts/${post._id}`,
          {
            data: { authorId: user.userId },
          },
          { headers: { Authorization: `Bearer ${token}` } }
        );
        toast.success("Deleted!");
        window.location.replace("/");
      } catch (err) {
        console.error(err);
        toast.error("Error Deleting Post!");
      }
    } else {
    }
  };
  const handleUpdate = async () => {
    try {
      await axios.put(
        `/posts/${post._id}`,
        {
          authorId: user.userId,
          title: post.title,
          desc: desc,
        },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      toast.success("Updated!");
      setUpdateMode(false);
    } catch (err) {
      console.error(err);
      toast.error("Error Updating Post!");
    }
  };
  const handleCopy = async () => {
    await navigator.clipboard.writeText(window.location.href);
    toast.info("Link Copied");
  };
  const handleLike = async () => {
    if (user !== null) {
      if (active1) {
        if (post.likes.indexOf(user.userId) !== -1) {
          post.likes.pop(user.userId);
        }
        try {
          await axios.put(
            `/posts/${post._id}`,
            {
              likes: post.likes,
            },
            { headers: { Authorization: `Bearer ${token}` } }
          );
        } catch (e) {
          console.error(e);
          toast.error("Error!");
        }
      } else {
        if (post.likes.indexOf(user.userId) === -1) {
          post.likes.push(user.userId);
        }
        try {
          await axios.put(
            `/posts/${post._id}`,
            {
              likes: post.likes,
            },
            { headers: { Authorization: `Bearer ${token}` } }
          );
        } catch (e) {
          console.error(e);
          toast.error("Error Liking Post!");
        }
      }
      setActive1(!active1);
    } else {
      toast.info("Please login to continue your action!");
    }
  };
  const handleAdding = async (e) => {
    if (user != null) {
      e.preventDefault();
      setActive2(!active2);

      if (!active2) toast.info("Adding to Reading List!");
      else toast.info("Removed from Reading List!");
      dispatch({ type: "UPDATE_START" });
      try {
        let currentRL = user.readingList;
        if (currentRL.indexOf(post._id) === -1) {
          currentRL.push(post._id);
        } else {
          currentRL.splice(currentRL.indexOf(post._id), 1);
        }
        const updatedUser = {
          id: user._id,
          readingList: currentRL,
        };
        try {
          const res = await axios.put("/users/" + user._id, updatedUser);
          if (res.status !== 200) {
            toast.info(res.data.message);
          }
          dispatch({ type: "UPDATE_SUCCESS", payload: res.data });
        } catch (err) {
          dispatch({ type: "UPDATE_FAILURE" });
          toast.error("Error!");
        }
      } catch (err) {
        console.log(err);
        toast.error("Error Saving Post!");
      }
    } else {
      toast.info("Please login to continue your action!");
    }
  };
  const handleFollow = async (e) => {
    e.preventDefault();
    dispatch({ type: "UPDATE_START" });
    if (active3) {
      try {
        const res = await axios.put(`/users/${user._id}/unfollow`, {
          userId: post.authorId,
        });
        if (res.status !== 200) {
          toast.info(res.data.message);
        }
        setFollowers(followers - 1);
        if (res.status === 200) {
          setActive3(!active3);
        }

        dispatch({ type: "UPDATE_SUCCESS", payload: res.data });
      } catch (e) {
        dispatch({ type: "UPDATE_FAILURE" });
        toast.error("Error Unfollowing User!");
      }
    } else {
      try {
        const res = await axios.put(`/users/${authorId}/follow`, {
          userId: user._id,
        });
        if (res.status !== 200) {
          toast.info(res.data.message);
        }
        setFollowers(followers + 1);
        if (res.status === 200) {
          setActive3(!active3);
        }
        dispatch({ type: "UPDATE_SUCCESS", payload: res.data });
      } catch (e) {
        dispatch({ type: "UPDATE_FAILURE" });
        toast.error("Error Following User!");
      }
    }
  };

  const { wordCount, readingTime } = useMemo(() => {
    const getWordCount = (htmlString) => {
      if (!htmlString) return 0;

      // 1. Remove image elements
      let cleaned = htmlString.replace(/<img[^>]*>/gi, " ");
      cleaned = cleaned.replace(/<div[^>]*class="ql-customImage"[^>]*>[\s\S]*?<\/div>/gi, " ");

      // 2. Decode HTML entities
      const textarea = document.createElement("textarea");
      textarea.innerHTML = cleaned;
      let decoded = textarea.value;

      // 3. Strip all remaining HTML tags
      decoded = decoded.replace(/<[^>]*>/g, " ");

      // 4. Normalize punctuation and spacing
      decoded = decoded
        .replace(/[\u2014\u2013—–]/g, "—")
        .replace(/\u00A0/g, " ")
        .replace(/\u2026|\.\.\./g, "...")
        .replace(/[“”‘’]/g, "'")
        .replace(/["]/g, '"')
        .replace(/’/g, "'")
        .replace(/(\S)(\.\.\.)/g, '$1 ...')
        .replace(/(\.\.\.)(\S)/g, '... $2')
        .replace(/(\S)([—])/g, '$1 —')
        .replace(/([—])(\S)/g, '— $2')
        .replace(/\s+/g, " ")
        .trim();

      // 5. Tokenize by space
      const tokens = decoded.split(" ");
      const dropped = [];

      // 6. Unicode-aware word validation
      const words = tokens.filter(word => {
        const cleaned = word.replace(/^[^\p{L}\p{N}'"-]+|[^\p{L}\p{N}'"-]+$/gu, '');
        const isValid = /[\p{L}\p{N}]/u.test(cleaned);
        if (!isValid) dropped.push(word);
        return isValid;
      });

      return words.length;
    };

    const wordCount = getWordCount(post.desc);
    const readingTime = Math.max(1, Math.ceil(wordCount / 200)); // avg reading speed assuming 200 wpm
    return { wordCount, readingTime };
  }, [post.desc]);

  const canonicalUrl = typeof window !== "undefined" ? window.location.href : "";
  const plainDesc = (post.metaDescription || post.shortDesc || "").replace(/<[^>]*>/g, "");
  const safeDesc = plainDesc.slice(0, 155);

  return (
    <>
    <Helmet>
      <title>{post.seoTitle || post.title}</title>
      <meta name="description" content={safeDesc} />
      <meta name="reading-time" content={`${readingTime} minute${readingTime > 1 ? "s" : ""}`} />
      <link rel="canonical" href={canonicalUrl} />

      {/* Open Graph */}
      <meta property="og:title" content={post.seoTitle || post.title} />
      <meta property="og:description" content={safeDesc} />
      <meta property="og:image" content={post.featuredImage?.src || (post.photo ? (post.photo.startsWith("http") ? post.photo : PF + post.photo) : undefined)} />
      <meta property="og:type" content="article" />

      {/* Twitter Card */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={post.seoTitle || post.title} />
      <meta name="twitter:description" content={safeDesc} />
      <meta name="twitter:image" content={post.featuredImage?.src || (post.photo.startsWith("http") ? post.photo : PF + post.photo)} />

      {/* Schema.org Structured Data */}
      {post.title && (
        <script type="application/ld+json">

          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "Article",
            mainEntityOfPage: {
              "@type": "WebPage",
              "@id": window.location.href
            },
            headline: post.title,
            image: post.featuredImage?.src,
            author: {
              "@type": "Person",
              name: authorName || "Unknown",
            },
            publisher: {
              "@type": "Organization",
              name: "For Love of Writers",
              logo: {
                "@type": "ImageObject",
                url: "https://myflowimages.s3.us-east-2.amazonaws.com/frontend/FLOW_logo.png"
              }
            },
            datePublished: post.publishedAt,
            dateModified: post.updatedAt || post.publishedAt,
            description: safeDesc,
            wordCount,
            timeRequired: `PT${readingTime}M`,
            articleSection: post.categories.join(", "),
            keywords: post.tags.map(t => t.tag_slug).join(", ")
          })}

        </script>
      )}
    </Helmet>
    <div className="singlePostContainer">
      <div className="singlePost">
        <div className="singlePostWrapper">
          {updateMode ? (
            <input
              type="text"
              value={post.title}
              className="singlePostTitleInput"
              autoFocus
              onChange={(e) => setPost({ ...post, title: e.target.value })}
            />
          ) : (
            <h1 className="singlePostTitle">
              {decodeHtml(post.title)}
              {user && post.authorId === user.userId && (
                <div className="singlePostEdit">
                  <i
                    className="singlePostIcon far fa-edit"
                    onClick={() => setUpdateMode(true)}
                  ></i>
                  <i
                    className="singlePostIcon far fa-trash-alt"
                    onClick={handleDelete}
                  ></i>
                </div>
              )}
            </h1>
          )}
          {(post.featuredImage?.src || post.photo) && (
            <figure className="featured-image-wrapper">
              <img
                src={post.featuredImage?.src || (post.photo.startsWith("http") ? post.photo : PF + post.photo)}
                srcSet={
                  post.featuredImage?.variants?.length
                    ? post.featuredImage.variants
                        .map((v) => `${v.webp || v.jpeg} ${v.width}w`)
                        .join(", ")
                    : undefined
                }
                sizes="(max-width: 768px) 100vw, 800px"
                width={post.featuredImage?.width || 800}
                height={post.featuredImage?.height || 450}
                alt={post.featuredImage?.alt || post.alt || post.title}
                loading="lazy"
                decoding="async"
                className="singlePostImg"
              />
              {(post.featuredImage?.caption  || post.caption) && (
                <figcaption className="image-caption">
                  {post.featuredImage?.caption || post.caption}
                </figcaption>
              )}
              {(post.featuredImage?.attribution || post.attribution) && (
                <div className="image-attribution">
                  Image credit: {post.featuredImage?.attribution || post.attribution}
                </div>
              )}
            </figure>
          )}
          <div className="singlePostInfo">
            <span className="singlePostAuthor">
              Author:
              <Link to={`/author/${post.authorId}`} className="link">
                <b> {authorName}</b>
              </Link>
            </span>
            <span className="singlePostDate">
              {post.publishedAt
                ? new Date(post.publishedAt).toDateString()
                : `Draft • Last saved ${new Date(post.updatedAt || post.createdAt).toLocaleString()}`}
            </span>
          </div>
          <div className="viewLikeShare">
            <div className="viewLikeShare-left">
              <span className="singlePostDate">
                {readingTime} min read · {wordCount} words
              </span>
              {/* <span className="singlePostView">
                <p>View: {post.views}</p>
              </span>
              <span className="singlePostLike">
                <p>Likes: { post.likes.length}</p>
              </span>
              <span className="singlePostShare">
                <p>Shares: 

                <FacebookShareCount url={window.location.href}>
                    {shareCount => <span className="myShareCountWrapper">{shareCount}</span>}
                </FacebookShareCount>
                </p>
              </span> */}
            </div>
            <div className="viewLikeShare-right">
              <div className="fb-share">
                <FacebookShareButton
                  url={window.location.href}
                  quote={""}
                  hashtag={"#ForLoveOfWriters"}
                  description={"Facebook share button"}
                  className="fbshare"
                >
                  <FacebookIcon size={28} round />
                </FacebookShareButton>
              </div>
              <div className="twitter-share">
                <TwitterShareButton
                  url={window.location.href}
                  quote={""}
                  hashtags={["ForLoveOfWriters"]}
                  description={"Twitter share button"}
                  className="twittershare"
                >
                  <TwitterIcon size={28} round></TwitterIcon>
                </TwitterShareButton>
              </div>
              <div className="copy-link">
                <i
                  className="sidebarIcon-post fa fa-link"
                  aria-hidden="true"
                  onClick={handleCopy}
                ></i>
              </div>
              <div className="like">
                <i
                  className="sidebarIcon-post fa fa-heart"
                  aria-hidden="true"
                  onClick={handleLike}
                  style={{ color: active1 ? "red" : "grey" }}
                ></i>
                <p>{post.likes.length}</p>
              </div>
              <div className="adding">
                <i
                  className="sidebarIcon-post fa fa-bookmark"
                  aria-hidden="true"
                  onClick={handleAdding}
                  style={{ color: active2 ? "green" : "grey" }}
                ></i>
              </div>
            </div>
          </div>
          <br></br>
          {isPro && !checkMember && authorId !== user.userId ? (
            <div>
              <div className="notify-membership">
                <h2>
                  Read this story from <i>{authorName}</i> — and more like it with a subscription.
                </h2>
                <ul className="ul-notify-membership">
                  <li>Enjoy unlimited access to our entire library.</li>
                  <li>Support the writers you love!</li>
                </ul>
                <Link to="/subscribe">
                  <button className="buttonx button3x">
                    <span>Subscribe Now</span>
                  </button>
                </Link>
              </div>
            </div>
          ) : (
            <div>
              {updateMode ? (
                <MyEditor
                  handleChange={(data) => {
                    setDesc(data);
                    setPost({ ...post, desc: data });
                  }}
                  data={post.desc}
                />
              ) : (
                <div
                  className="singlePostDesc"
                  ref={(el) => {
                    if (el) {
                      const imgs = el.querySelectorAll("img");
                      imgs.forEach((img) => {
                        img.onload = () => {
                          const isPortrait = img.naturalHeight > img.naturalWidth;
                          img.classList.add(isPortrait ? "img-portrait" : "img-landscape");
                        };
                        if (img.complete) {
                          const isPortrait = img.naturalHeight > img.naturalWidth;
                          img.classList.add(isPortrait ? "img-portrait" : "img-landscape");
                        }
                      });
                    }
                  }}
                  dangerouslySetInnerHTML={{ __html: post.desc }}
                />
              )}
              {updateMode && (
                <button className="singlePostButton" onClick={handleUpdate}>
                  Update
                </button>
              )}
              <div className="tag-block">
                <h4>Tags:</h4>
                <div className="tag-section">
                  {tags.map((t) => (
                    <Link to={`/search?q=${t.tag_slug}`} className="tag-span" key={t.tag_slug}>
                      {t.tag_slug}
                    </Link>
                  ))}
                </div>
              </div>
            </div>
          )}
        </div>
      </div>

      <div className="separator"></div>

      <div className="sidebar-SinglePost">
        <div className="sidebarItem">
          {/* <span className="sidebarTitle">ABOUT AUTHOR</span> */}

          <Link to={`/author/${post.authorId}`} className="link">
            <span className="authorName">{authorName}</span>
          </Link>

          <Link to={`/author/${post.authorId}`}>
            <img src={profilePic} alt={`Photo of ${authorName}`} className="author-image" />
          </Link>

          {/* <span className="authorFollowers">{followers} Followers</span> */}
        </div>
        <div className="div-follow">
          <button
            type="submit"
            id="btnFollow"
            className="btn-follow"
            onClick={handleFollow}
          >
            {active3 ? "Unfollow" : "Follow"}
          </button>
          <p>{warning}</p>
        </div>
        <br />
        {authorBio.length === 0 ? (
          <></>
        ) : (
          <div className="authorBio">{authorBio}</div>
        )}
      </div>
    </div>
    </>
  );
}
